import React, { useState } from "react";
import { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import { motion } from "framer-motion";

import Skeleton from "../../../components/Skeleton";
import "./index.css";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";

const Casos = () => {
  const [casos, setCasos] = useState({});
  const [casosLoaded, setCasosLoaded] = useState(false);
  const [error, setError] = useState(false);
  const URL = "http://186.182.64.114:3005/api/proyectos?offset=0&limit=10";

  const getCasos = async () => {
    try {
      const response = await fetch(URL);
      const status = response.status;
      if (status !== 200) {
        setCasosLoaded(true);
        setError(true);
      }
      console.log(status);
      const data = await response.json();
      status === 200 && setCasosLoaded(true);
      return setCasos(data);
    } catch (error) {
      setCasosLoaded(true);
      setError(true);
      console.log(error);
    }
  };

  useEffect(() => {
    getCasos();
  }, []);

  return (
    <div className="casos section relative noPadTop">
      <div className="container-lg flex flexCol">
        {!casosLoaded ? (
          <Skeleton items={6} />
        ) : !error ? (
          <div className="casosDiv">
            {Object.values(casos).map((caso) => (
              <motion.div className="casoscard" key={caso.id}>
                <div className="contentCaso">
                  <h3>{caso.nombre}</h3>
                  <p>{caso.descripcion}</p>
                  <div className="challenge">
                    <h4>Challenge</h4>
                    <p>{caso.challenge}</p>
                  </div>
                  <div className="tecno">
                    {caso.tecnologias.split(", ").map((tecnologia, index) => (
                      <span key={index}>{tecnologia}</span>
                    ))}
                  </div>
                </div>
                <div className="galCaso">
                  <Swiper
                    className="galeriaCasos"
                    effect={"coverflow"}
                    modules={[Autoplay]}
                    grabCursor={true}
                    speed={1500}
                    centeredSlides={true}
                    autoplay={{
                      delay: 3000,
                    }}
                    loop
                    slidesPerView={1}
                  >
                    {caso.imagenes.map((img, index) => (
                      <SwiperSlide key={index}>
                        <img src={img.base64Content} alt="Img" />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </motion.div>
            ))}
          </div>
        ) : (
          <h3>Hubo un error al cargar los casos</h3>
        )}
      </div>
    </div>
  );
};

export default Casos;
